// extracted by mini-css-extract-plugin
module.exports = {"oldValue":"PolicyDiffComponent_oldValue__3yt_9","newValue":"PolicyDiffComponent_newValue__blVxW"};